import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../../../../components/ui/card";
import { Separator } from "../../../../../components/ui/separator";
import { Skeleton } from "../../../../../components/ui/skeleton";
import { BaixaItem } from "../types";
import { BaixaItemCard } from "./baixa-item-card";

interface BaixaOperationSectionProps {
  operationName: string;
  baixaList: BaixaItem[];
  isLoading: boolean;
  onStartDoc: (filterDate: string, ops: string) => void;
  onSubmitDb: (filterDate: string, ops: string) => void;
  isStartingDoc: boolean;
  isSubmittingDb: boolean;
}

export function BaixaOperationSection({
  operationName,
  baixaList,
  isLoading,
  onStartDoc,
  onSubmitDb,
  isStartingDoc,
  isSubmittingDb,
}: BaixaOperationSectionProps) {
  if (isLoading) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center space-y-4">
            <div className="flex justify-center">
              <Skeleton className="h-12 w-12 rounded-full" />
            </div>
            <Skeleton className="h-4 w-64 mx-auto" />
          </div>
        </CardContent>
      </Card>
    );
  }

  if (!Array.isArray(baixaList) || baixaList.length === 0) {
    return (
      <Card>
        <CardContent className="py-12">
          <div className="text-center">
            <CardTitle className="text-xl">
              Não há baixas de {operationName.toUpperCase()} para serem
              finalizadas
            </CardTitle>
          </div>
        </CardContent>
      </Card>
    );
  }

  return (
    <div className="space-y-6">
      <CardHeader className="px-0 pt-0">
        <CardTitle className="text-2xl">
          {operationName.toUpperCase()}
        </CardTitle>
      </CardHeader>
      {baixaList.map((baixa, index) => (
        <div key={`${baixa.data_vencimento}-${index}`}>
          <BaixaItemCard
            baixaItem={baixa}
            ops={operationName}
            onStartDoc={onStartDoc}
            onSubmitDb={onSubmitDb}
            isStartingDoc={isStartingDoc}
            isSubmittingDb={isSubmittingDb}
          />
          {index < baixaList.length - 1 && <Separator className="my-6" />}
        </div>
      ))}
    </div>
  );
}
